export default "__VITE_ASSET__BHoNJD$3__"